module.exports = __webpack_public_path__ + "img/interview3.25aafd7c.png";